import { useEffect } from 'react';
import { useTenantData } from '../../contexts/TenantDataContext';
import { useAppConfig } from '../../contexts/AppConfigContext';

/**
 * Pushes the tenant's <c>company</c> object into the Intercom messenger
 * whenever the cached <c>companySettings.businessName</c> changes.
 *
 * Lives inside <c>TenantProviders</c> (below <c>TenantDataProvider</c>) so
 * it can read the company data context. <c>IntercomProvider</c> itself sits
 * higher in the tree (it has to run for host-admin routes too, which don't
 * have tenant data), so the user identity is booted there and the company
 * is layered on by this component once tenant data loads.
 *
 * Renders nothing — pure side effect.
 */
const IntercomCompanyUpdater = () => {
  const { companySettings } = useTenantData();
  const { config } = useAppConfig();
  const tenantId = config?.currentTenant?.id;
  const businessName = companySettings?.businessName;

  useEffect(() => {
    if (typeof window === 'undefined' || !window.Intercom) return;
    if (!tenantId) return;

    window.Intercom('update', {
      company: {
        company_id: tenantId,
        name: businessName || undefined,
      },
    });
  }, [tenantId, businessName]);

  return null;
};

export default IntercomCompanyUpdater;
